import { create } from 'zustand';
import type { AuthExchangeResult } from '../lib/api.js';
import { api, setSessionToken } from '../lib/api.js';

type Status = 'idle' | 'authing' | 'ready' | 'error';

interface AuthState {
  status: Status;
  user: AuthExchangeResult['user'] | null;
  token: string | null;
  error: string | null;
  signInWithInitData: (initData: string) => Promise<void>;
  refresh: () => Promise<void>;
  reset: () => void;
}

export const useAuth = create<AuthState>((set) => ({
  status: 'idle',
  user: null,
  token: null,
  error: null,

  async signInWithInitData(initData: string) {
    set({ status: 'authing', error: null });
    try {
      const result = await api.exchangeInitData(initData);
      setSessionToken(result.token);
      set({ status: 'ready', user: result.user, token: result.token });
    } catch (err) {
      const message = err instanceof Error ? err.message : 'auth failed';
      set({ status: 'error', error: message });
    }
  },

  async refresh() {
    try {
      const fresh = await api.me();
      set({ user: fresh });
    } catch {
      // network blip — keep the cached user
    }
  },

  reset() {
    setSessionToken(null);
    set({ status: 'idle', user: null, token: null, error: null });
  },
}));
